<template>
 <div id="cashOutRoot">
  <div id="cashOutContainer">
    <div id="coTitleDiv">
      红包提现
    </div>
    <img id="coBackImg" src="~assets/img//rebate-center/left_back_arrow_red.png" @click="hideCashOutPage()"/>
    <div>
      <img v-if="$store.state.openRebateUI1" id="coAvatarIcon" src="~assets/img/rebateUI1/avatar-icon.png"/>
      <img v-else id="coAvatarIcon" src="~assets/img/rebate-center/avatar-icon.png"/>
    </div>
    <div v-if="exchangeType" id="coCashOutMoney">
      提现金额：{{$store.state.userInfoData.dividemoney}}元
      <span v-if="$store.state.userInfoData.wxuser === '0'" @click="wxBind">
        <img id="coWxbindIcon" src="~assets/img//rebate-center/wx-unbind.png"/>
      </span>
      <span v-else>
        <img id="coWxbindIcon" src="~assets/img//rebate-center/wx-bind.png"/>
      </span>
    </div>
    <div v-else id="coCashOutMoney">
      提现金额：{{$store.state.userInfoData.money}}元
      <span v-if="$store.state.userInfoData.wxuser === '0'" @click="wxBind">
        <img id="coWxbindIcon" src="~assets/img//rebate-center/wx-unbind.png"/>
      </span>
      <span v-else>
        <img id="coWxbindIcon" src="~assets/img//rebate-center/wx-bind.png"/>
      </span>
    </div>
    
    <div id="coRecordParent" @click="openExchangeRecords">
      提现记录
      <img id="coArrowRight" src="~assets/img//rebate-center/left_back_arrow_grey.png"/>
    </div>

    <div id="coMoneyParent">
      <label id="coMoneySimbol">￥</label>
      <label id="coMoneyValue">{{showSelectedExchangeMoney}}元</label>
    </div>
    <HR style="border:1 dashed #987cb9;" width="95%" color=gray SIZE=1></HR>

    <div id="coMoneyOptionsParent">
      <!-- 瓜分红包的兑换列表 -->
      <span v-if="exchangeType"><DivideExchangeOptions v-on:selectedExchangeMoney="selectedExchangeMoney"/></span>
      <!-- 等级红包的兑换列表 -->
      <span v-else><LevelExchangeOptions v-on:selectedExchangeMoney="selectedExchangeMoney"/></span>
    </div>
    <div id="showSelectedMoneyDiv">选中金额:{{showSelectedExchangeMoney}}元</div>
    
    <div>
      <div id="exchangeBtn" @click="exchange" :style="{'background':'linear-gradient(to right,'+$store.state.exchangeSelectedStartColor+', '+$store.state.exchangeSelectedEndColor+')'}">立 即 提 现</div>
    </div>
  </div>
  <ExchangeLog v-if="showExchangeLogPage" :logRecords="logRecords" @setExchangeLogClose="setExchangeLogClose"/>
 </div>
</template>

<script>
import MoneyOptionItem from 'views/RebateView/CashOut/MoneyOptionItem.vue'
import LevelExchangeOptions from './LevelExchangeOptions.vue'
import DivideExchangeOptions from './DivideExchangeOptions.vue'
import Loading from 'views/loading/Loading.vue'
import ExchangeLog from "views/RebateView/ExchangeLog/ExchangeLog.vue"
import getRequestParams from "@/signParams";
import { request } from 'network/request';

 export default {
   data () {
     return {
        // 兑换列表显示类型，是瓜分红包(1)还是等级红包(2)
        exchangeType: this.$store.state.exchangeType === 1,
        showSelectedExchangeMoney: "0",
        handleExchange: false,// 是否正在处理兑换，避免多次点击兑换按钮,
        showExchangeLogPage: false,
        logRecords: []
     }
   },
   components: {
    MoneyOptionItem,LevelExchangeOptions,DivideExchangeOptions,Loading,ExchangeLog
   },
   methods:{
    hideCashOutPage(){
      this.$emit("setCloseCashOutPage");
    },
    // 接收 DivideExchangeOptions 和 LevelExchangeOptions 的选择金额数据
    selectedExchangeMoney(selectedMoney){
      this.showSelectedExchangeMoney = selectedMoney;
    },
    // 显示兑换记录页面
    openExchangeRecords(){
      // 先查询有没有记录
      let storeCommomParams = this.$store.getters.getCommomParams;
      let levelRebateReceiveReqParams = getRequestParams({},storeCommomParams);
      request({
        url:this.urls.REBATE_EXCHANGELOG,
        params: {
          data: levelRebateReceiveReqParams
        },
      }).then(res =>{
        let logList = JSON.parse(res.exchangeLog);
        if (logList.length < 1) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "暂无兑换记录"});
        }else {
          this.logRecords = logList;
        }
      });
    },
    // 立即兑换
    exchange(){
      // console.log("调用兑换接口");
      if(this.showSelectedExchangeMoney === "0"){
        return;
      }
      if (this.handleExchange) {
        // console.log("正在处理兑换逻辑。。。不要那么急");
        return;
      }
      // console.log("兑换开始....");
      // this.$store.commit('switchLoading', true);
      // 调用兑换接口
      this.handleExchange = true;
      let storeCommomParams = this.$store.getters.getCommomParams;
      let levelRebateReceiveReqParams = getRequestParams({"amount":this.showSelectedExchangeMoney},storeCommomParams);
      request({
        url:this.urls.REBATE_EXCHANGE,
        params: {
          data: levelRebateReceiveReqParams
        },
      }).then(res =>{
        this.$store.dispatch("networkExchange", res)
        this.handleExchange = false;
      }).catch(error => {
        let errorMessage = error["message"];
        // console.log(error["message"]);
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": errorMessage});
        // 该账号未绑定提取方式
        if ("该账号未绑定提取方式" === errorMessage) {
            this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "该账号未绑定提取方式"});
            this.wxBind();
          }
        this.handleExchange = false;
      });
    },
    setExchangeLogClose(){
      this.showExchangeLogPage = false;
    },
    // 微信未绑定，点击的时候显示微信二维码绑定页面
    wxBind(){
      // console.log("点击绑定微信");
      let storeCommomParams = this.$store.getters.getCommomParams;
      // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
      let wxBindReqParams = getRequestParams({},storeCommomParams);
      request({
        url:this.urls.REBATE_WXAUTH,
        params: {
          data: wxBindReqParams
        },
      }).then(res =>{
        // console.log(res);
        // console.log(JSON.parse(res.param)['url']);
        if("qrcode" == res.type){
          let qrcodeUrl = JSON.parse(res.param)['url'];
          this.$store.dispatch('networkWxBindPageShow', {"showOrHide":true, "qrcodeUrl": qrcodeUrl})
        }else{
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "暂无绑定方式"})
          this.$store.dispatch('networkWxBindPageShow', {"showOrHide":false, "qrcodeUrl": ""})
        }
      })
    }
   }
 }
</script>

<style>
#cashOutRoot{
    /* display: none; */
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(51,51,51,0.5);
    z-index: 133;
  }
  #cashOutContainer{
    width: 300px;
    height: 300px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 155;
    border-radius: 10px 10px 10px 10px;
  }

  #coTitleDiv{
    width: 300px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: large;
    font-weight: bold;

   }
   
   #coBackImg{
    float: left;
    height: 30px;
    width: 30px;
    /* 解决图片拉伸问题 */
    object-fit: scale-down;
    margin-top: -30px;
    margin-left: 5px;
   }
  
  #coAvatarIcon{
    float: left;
    height: 57px;
    width: 57px;
    margin-top: 10px;
    margin-left: 10px;
    /* 解决图片拉伸问题 */
    object-fit: scale-down;
  }
  #coCashOutMoney{
    margin-top: 10px;
    display: flex;
    flex-flow: column;
    float: left;
    width: auto;
    height: 57px;
    line-height: 20px;
    text-align: center;
    font-size: smaller;
  }
  
  #coWxbindIcon{
    flex: 1;
    height: 20px;
    width: 60px;
    margin-top: 10px;
    /* 解决图片拉伸问题 */
    object-fit: scale-down;
  }
  #coRecordParent{
    margin-top: 10px;
    float: right;
    width: 90px;
    height: 57px;
    line-height: 57px;
    text-align: center;
    font-size: smaller;
  }
 
  #coArrowRight{
    float: right;
    height: 27px;
    width: 20px;
    margin-top: 15px;
    transform: rotate(180deg);
  }

  /* 可兑换余额的父级div */
  #coMoneyParent{
    float: left;
    display: flex;
    width: 100%;
    height: 45px;
    flex-direction: row;
    margin-top: 10px;
    justify-content: center; /*水平居中*/
    align-items: Center; /*垂直居中*/
  }

  /* 人民币符号 */
  #coMoneySimbol{
    margin-left: 20px;
    flex: 1;
    color: black;
    font-size: large;
    font-weight: bolder;
  }
  /* 可兑换余额 */
  #coMoneyValue{
    flex: 9;
    color: black;
    font-size: large;
    font-weight: bolder;
  }

  /* 兑换列表下面的文字div */
  #showSelectedMoneyDiv{
    float: left;
    display: flex;
    width: 100%;
    font-size: small;
    flex-direction: row;
    justify-content: center; /*水平居中*/
    align-items: Center; /*垂直居中*/
  }

  /* 立即提现 */
  #exchangeBtn{
    margin-left: 15%;
    float: left;
    display: flex;
    width: 70%;
    /* background-color: red; */
    font-size: smaller;
    margin-top: 15px;
    height: 35px;
    flex-direction: row;
    justify-content: center; /*水平居中*/
    align-items: Center; /*垂直居中*/
    border-radius: 20px 20px 20px 20px;/*左上右下*/
    color: white;
    /* background: linear-gradient(to right,#FF9063, #FF3948); */
  }
</style>


// WEBPACK FOOTER //
// src/views/RebateView/CashOut/CashOut.vue